import React from 'react';
import { ArrowUp, Linkedin, Twitter, Github } from 'lucide-react';
import styles from './Footer.module.css';

const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'How We Work', href: '#how-we-work' },
  { label: 'Results', href: '#results' },
  { label: 'Contact', href: '#contact' },
];

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.grid}>
          <div className={styles.brand}>
            <div className={styles.brandName}>BlueprintX</div>
            <p className={styles.brandTagline}>Business Transformation &amp; AI Engineering</p>
            <p className={styles.brandLocation}>Amsterdam (Global HQ) | Chennai (Engineering Hub)</p>
            <div className={styles.social}>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="LinkedIn">
                <Linkedin size={18} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="Twitter">
                <Twitter size={18} />
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="GitHub">
                <Github size={18} />
              </a>
            </div>
          </div>

          <nav className={styles.nav}>
            {navLinks.map((link) => (
              <a key={link.label} href={link.href} className={styles.navLink}>
                {link.label}
              </a>
            ))}
          </nav>

          <div className={styles.contact}>
            <a href="mailto:info@blueprintx.net" className={styles.contactEmail}>
              info@blueprintx.net
            </a>
            <a
              href="https://blueprintx.net"
              className={styles.contactSite}
              target="_blank"
              rel="noopener noreferrer"
            >
              blueprintx.net
            </a>
          </div>
        </div>

        <div className={styles.bottom}>
          <p className={styles.copyright}>
            &copy; 2026 BlueprintX. All rights reserved.
          </p>
          <button className={styles.backToTop} onClick={scrollToTop} aria-label="Back to top">
            <ArrowUp size={16} />
            <span>Back to top</span>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
